import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PathwayWithComment } from '../signal-results/signal-results.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'gen-ruler-graph',
  templateUrl: './ruler-graph.component.html',
  styleUrls: ['./ruler-graph.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RulerGraphComponent implements OnInit {

  @Input()
  model: any;
  @Input()
  pathwayWithComment: Observable<PathwayWithComment>;

  // public pathway = {};

  // Todo check acces modifier
  private dropImgPath: string;
  public scorePosition: string;
  public width: string;
  public rangeLeft: string;
  public qcPassed: boolean;

  public score: number;
  loMin: number;
  loMax: number;
  calMax: number;
  calMin: number;
  rangeMin: number;
  rangeMax: number;
  log2odds: number;

  constructor() {
    this.dropImgPath = '/assets/orange-tip/orange-tip.svg';
  }

  ngOnInit() {
    // TODO move to method , code split
  this.model = JSON.parse(this.model);
  // this.qcPassed = !!this.model.QC_pathway;
  this.qcPassed = this.model.QC_pathway !== undefined ? this.model.QC_pathway  : true;
  this.loMin = this.model.activity.loMin;
  this.loMax = this.model.activity.loMax;
  this.calMax = this.model.activity.calMax;
  this.calMin = this.model.activity.calMin;
  this.log2odds = this.model.activity.log2odds;
  this.score = Math.round((((this.log2odds - this.calMin) / (this.calMax - this.calMin)) * 100));
  this.rangeMin = ((this.loMin - this.calMin) / (this.calMax - this.calMin)) * 100;
  this.rangeMax = ((this.loMax - this.calMin) / (this.calMax - this.calMin)) * 100;
  this.width = this.rangeMax - this.rangeMin + '%';
  this.scorePosition = this.score + '%';
  this.rangeLeft = this.rangeMin + '%';
  }


}

